import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Bets } from '../../../config/bets';

import { AutoCashoutObjProps, CashoutMultiplierForAutoPlay, CashoutMultiplierParams } from './types';

type AutoCashoutSliceProps = Record<Bets, AutoCashoutObjProps>;
const initialState: AutoCashoutSliceProps = {
  [Bets.ONE]: {
    isEnabled: false,
    cashoutMultiplier: '1.01',
    lastValue: '1.01',
    isAutoCashoutFinalized: false,
  },
  [Bets.TWO]: {
    isEnabled: false,
    cashoutMultiplier: '1.01',
    lastValue: '1.01',
    isAutoCashoutFinalized: false,
  },
};
export const autoCashoutSlice = createSlice({
  name: 'autoCashout',
  initialState: initialState,
  reducers: {
    toggleAutoCashout: (state, action: PayloadAction<Bets>): void => {
      state[action.payload] = {
        ...state[action.payload],
        isEnabled: !state[action.payload].isEnabled,
      };
    },
    setAutoCashoutButton: (state, action: PayloadAction<CashoutMultiplierForAutoPlay>): void => {
      state[action.payload.betCode].isEnabled = action.payload.isEnabled;
    },
    setCashoutMultiplier: (state, action: PayloadAction<CashoutMultiplierParams>): void => {
      state[action.payload.betCode] = {
        ...state[action.payload.betCode],
        cashoutMultiplier: action.payload.cashoutMultiplier,
        lastValue: action.payload?.isAutoCashoutFinalized
          ? action.payload.cashoutMultiplier
          : state[action.payload.betCode].lastValue,
        isAutoCashoutFinalized: action.payload?.isAutoCashoutFinalized ? true : false
      };
    },
  },
});

export const autoCashoutActions = autoCashoutSlice.actions;
